/* eslint-disable @typescript-eslint/unbound-method */
import { selectAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(selectAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    fontWeight: 'normal',
  },
});

export const selectTheme = defineMultiStyleConfig({
  baseStyle,
  defaultProps: {
    size: 'sm',
    variant: 'outline',
  },
});
